import {DialogSeen} from '../../../../../controls/agyle/clinician/clinitian';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import moment from 'moment/moment';
import keyPerformanceIndicator from '../../../../../util/timeMarker';
import {getConfig} from '../../../../../util/configUtil';
import {ASSESSMENT_BUTTON_COLOURS} from '../../formsUtil';
import {consultantDictionary} from '../../../../../controls/agyle/clinician/clinitianUtils';
import Grid from '@mui/material/Grid';
import {patientBanner} from '../../../../../controls/agyle/tasks/components/patientBanner';
import ControlConsultantComponent from '../../../../../controls/agyle/clinician/controlConsultantComponent';
import AgyleDatePicker from '../../../../../components/ui/fields/agyleDatePicker';
import {calculateArrivalDate} from '../../../../../util/patientUtil';
import AgyleButton from '../../../../../components/ui/buttons/agyleButton';
import Notes from '../../../../../util/notes';

const SeniorReviewForm = (props) => {
    const {t} = useTranslation();

    // Configs
    const seniorReviewTimeToTreatment = getConfig('seniorReviewTimeToTreatment', false);
    const clinicalNotesFromForm = getConfig('clinicalNotesFromForm', false);

    const [fullFormMode, setFullFormMode] = React.useState(!props.isActionMode);

    const defaultSeniorReview = {
        who: null,
        when: moment(),
        text: '',
    };

    const [seniorReviewDataForm, setSeniorReviewDataForm] = useState(defaultSeniorReview);

    const getSRActionNote = React.useCallback(() => {
        return Notes.getActionSRNote(seniorReviewDataForm);
    }, [seniorReviewDataForm]);

    const handleSaveSRTimestamp = React.useCallback(() => {
        const objectToSave = {
            ...seniorReviewDataForm,
            status: 'timestamp',
        }

        let dataArray = [{
            name: "seniorReview",
            value: objectToSave,
            noteToAdd: getSRActionNote(),
        }]
        props.onChange(dataArray);
    }, [seniorReviewDataForm, getSRActionNote, props.onChange]);


    const handleSeniorReview = (value) => {

            const isSRSaved = !!value.who && !!value.when;

            const valueToSave = {
                ...value,
                status: isSRSaved ? 'completed' : null,
            }

            const dataToChange = [{
                name: 'seniorReview',
                value: valueToSave
            }];

            if (seniorReviewTimeToTreatment && value?.when) {
                keyPerformanceIndicator(
                    dataToChange,
                    props.patient,
                    ['firstClinicianSaved'],
                    {
                        when: value?.when,
                        who: value?.who,
                        status: value?.status,
                    },
                );
            }
            props.onChange(dataToChange);
    };

    useEffect(() => {

        if (props.agyleDialogInsertButtons) props.agyleDialogInsertButtons(buttons());

        if (props.onSubmitFunction) {
            props.onSubmitFunction(handleSaveSRTimestamp);
        }
        if (props.onDisableSubmit) {
            props.onDisableSubmit(isThereAnyNull());
        }

    }, [fullFormMode, handleSaveSRTimestamp, props.agyleDialogInsertButtons, props.onSubmitFunction, seniorReviewDataForm]);

    const isThereAnyNull = () => {
        return seniorReviewDataForm.who === null || seniorReviewDataForm.when === null;
    };

    const handleOpenFullFormTimestamp = () => {
        if (props.handleOpenFullFormTimestamp) props.handleOpenFullFormTimestamp();
    };

    const buttons = () => {
        const buttons = [];

        if (!fullFormMode) {
            buttons.push(
                <AgyleButton
                    onClick={handleOpenFullFormTimestamp}
                    variant="contained"
                    color="primary"
                >
                    {t('Open Form')}
                </AgyleButton>,
            );
            buttons.push(
                <AgyleButton
                    variant="contained"
                    color="primary"
                    onClick={handleSaveSRTimestamp}
                    disabled={isThereAnyNull()}
                >
                    {t('Submit')}
                </AgyleButton>,
            );
        }
        return buttons;
    };

    const handleChangeDate = (param) => {
        setSeniorReviewDataForm((pr) =>
            ({
                ...pr,
                when: param,
            }));
        setFullFormMode(false);
    }
    const handleChangeClinician = (param) => {
        setSeniorReviewDataForm((pr) =>
            ({
                ...pr,
                who: param,
            }));
        setFullFormMode(false);
    }

    return (
        <>
            {!fullFormMode &&
                <Grid container spacing={2} style={{padding: '10px'}}>
                    <Grid item xs={12}>
                        {patientBanner(props.patient, false)}
                    </Grid>
                        <Grid item xs={6}>
                            <ControlConsultantComponent
                                error={!seniorReviewDataForm.who}
                                agyleRefresh
                                label={t('Clinician')}
                                value={seniorReviewDataForm.who}
                                onChange={handleChangeClinician}
                                allowedConsultants={consultantDictionary.seniorReview}
                                size="large"
                                noBorder={false}
                                withNewBackground
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <AgyleDatePicker
                                label={t('Date and Time')}
                                value={seniorReviewDataForm.when}
                                minDate={moment(calculateArrivalDate(props.patient))}
                                maxDate={moment()}
                                error={!seniorReviewDataForm.when}
                                onChange={handleChangeDate}
                                size="large"
                                noBorder={false}
                                withNewBackground
                            />
                        </Grid>
                </Grid>
            }
            {fullFormMode &&
                <DialogSeen
                    patient={props.patient}
                    size="large"
                    label={t('Senior Review Clinician')}
                    open={props.open}
                    onClose={props.onClose}
                    allowedConsultants={consultantDictionary.seniorReview}
                    disableSave={props.disableSave}
                    color={
                        props.patient?.seniorReview?.who
                            ? ASSESSMENT_BUTTON_COLOURS.notMandatorySet
                            : ASSESSMENT_BUTTON_COLOURS.notMandatoryEmpty
                    }
                    withText
                    value={props.patient?.seniorReview || {who: null, when: moment(), text: ''}}
                    onChange={handleSeniorReview}
                    noteButton={clinicalNotesFromForm}
                    noteButtonType="Senior Review"
                    refresh
                />
            }
        </>
    );
};


export default SeniorReviewForm;